module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "sticky row border-bottom white-bg dashboard-header"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 text-center"
  }, [_c('div', {
    staticClass: "filters"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Filter by"
    },
    on: {
      "change": _vm.handleFiltersChanged
    },
    model: {
      value: (_vm.filterBy),
      callback: function($$v) {
        _vm.filterBy = $$v
      },
      expression: "filterBy"
    }
  }, [_c('el-option', {
    key: 'survey',
    attrs: {
      "value": 'survey',
      "label": 'Survey'
    }
  }), _vm._v(" "), _c('el-option', {
    key: 'period',
    attrs: {
      "value": 'period',
      "label": 'Period'
    }
  })], 1), _vm._v(" "), (_vm.filterBy === 'survey') ? _c('el-select', {
    attrs: {
      "placeholder": "Select survey",
      "filterable": "",
      "value": _vm.selectedSurvey
    },
    on: {
      "change": _vm.handleFiltersChanged
    },
    model: {
      value: (_vm.selectedSurvey),
      callback: function($$v) {
        _vm.selectedSurvey = $$v
      },
      expression: "selectedSurvey"
    }
  }, _vm._l((_vm.surveys), function(survey) {
    return _c('el-option', {
      key: survey.id,
      attrs: {
        "value": survey.id,
        "label": survey.title
      }
    })
  }), 1) : _vm._e(), _vm._v(" "), (_vm.filterBy === 'period') ? _c('el-select', {
    attrs: {
      "placeholder": "Select period",
      "filterable": ""
    },
    on: {
      "change": _vm.handleFiltersChanged
    },
    model: {
      value: (_vm.selectedPeriod),
      callback: function($$v) {
        _vm.selectedPeriod = $$v
      },
      expression: "selectedPeriod"
    }
  }, [_c('el-option', {
    key: 'month',
    attrs: {
      "value": 'month',
      "label": 'Monthly'
    }
  }), _vm._v(" "), _c('el-option', {
    key: 'quarter',
    attrs: {
      "value": 'quarter',
      "label": 'Quarterly'
    }
  }), _vm._v(" "), _c('el-option', {
    key: 'year',
    attrs: {
      "value": 'annual',
      "label": 'Yearly'
    }
  }), _vm._v(" "), _c('el-option', {
    key: 'lifetime',
    attrs: {
      "value": 'lifetime',
      "label": 'Lifetime'
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.filterBy === 'period' && _vm.selectedPeriod === 'month') ? _c('el-select', {
    attrs: {
      "placeholder": "Select month",
      "filterable": ""
    },
    on: {
      "change": _vm.handleFiltersChanged
    },
    model: {
      value: (_vm.selectedPeriodMonth),
      callback: function($$v) {
        _vm.selectedPeriodMonth = $$v
      },
      expression: "selectedPeriodMonth"
    }
  }, _vm._l((_vm.periods.month), function(item) {
    return _c('el-option', {
      key: item[0],
      attrs: {
        "value": item[0],
        "label": item[1]
      }
    })
  }), 1) : _vm._e(), _vm._v(" "), (_vm.filterBy === 'period' && _vm.selectedPeriod === 'quarter') ? _c('el-select', {
    attrs: {
      "placeholder": "Select quarter",
      "filterable": ""
    },
    on: {
      "change": _vm.handleFiltersChanged
    },
    model: {
      value: (_vm.selectedPeriodQuarter),
      callback: function($$v) {
        _vm.selectedPeriodQuarter = $$v
      },
      expression: "selectedPeriodQuarter"
    }
  }, _vm._l((_vm.periods.quarter), function(item) {
    return _c('el-option', {
      key: item[0],
      attrs: {
        "value": item[0],
        "label": item[1]
      }
    })
  }), 1) : _vm._e(), _vm._v(" "), (_vm.filterBy === 'period' && _vm.selectedPeriod === 'annual') ? _c('el-select', {
    attrs: {
      "placeholder": "Select year",
      "filterable": ""
    },
    on: {
      "change": _vm.handleFiltersChanged
    },
    model: {
      value: (_vm.selectedPeriodYear),
      callback: function($$v) {
        _vm.selectedPeriodYear = $$v
      },
      expression: "selectedPeriodYear"
    }
  }, _vm._l((_vm.periods.annual), function(item) {
    return _c('el-option', {
      key: item[0],
      attrs: {
        "value": item[0],
        "label": item[1]
      }
    })
  }), 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "total-display"
  }, [_c('el-radio-group', {
    attrs: {
      "size": "mini"
    },
    model: {
      value: (_vm.selectedTotalDisplay),
      callback: function($$v) {
        _vm.selectedTotalDisplay = $$v
      },
      expression: "selectedTotalDisplay"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "percentage"
    }
  }, [_vm._v("Percentage")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "total"
    }
  }, [_vm._v("Total")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "cume"
    }
  }, [_vm._v("Cume")])], 1)], 1)])]), _vm._v(" "), (!_vm.isValidFilter) ? _c('div', {
    staticClass: "row"
  }, [_vm._m(1)]) : _vm._e(), _vm._v(" "), (_vm.laodingSurveyAalytics) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('loader', {
    attrs: {
      "message": "Loading your surveys"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.isValidFilter && _vm.analyticsRowCount === 0 && !_vm.loadingCharts && !_vm.laodingSurveyAalytics) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('empty', [_vm._v("Not enough data has been gathered yet to display any results for your filter.")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.isValidFilter && _vm.analyticsRowCount > 0 && !_vm.laodingSurveyAalytics) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-10"
  }, [_c('h2', [_vm._v(_vm._s(_vm.currentCategory))]), _vm._v(" "), _vm._l((_vm.analyticsRowCount), function(i) {
    return _c('div', {
      key: i,
      staticClass: "row"
    }, _vm._l((_vm.analyticsChartsInRow(i)), function(item) {
      return _c('div', {
        key: item.id,
        staticClass: "col-lg-6"
      }, [_c('i-box', [_c('span', {
        attrs: {
          "slot": "title"
        },
        slot: "title"
      }, [_c('span', {
        staticClass: "pull-right text-muted text-right count"
      }, [_c('em', [_vm._v("n")]), _vm._v("\n                " + _vm._s(item.respondents) + "\n                "), _c('br'), _vm._v(" "), (item.chart !== 'WORDCLOUD') ? _c('span', {
        staticStyle: {
          "cursor": "pointer"
        }
      }, [_vm._v("\n                  [\n                  "), _c('a', {
        on: {
          "click": function($event) {
            return _vm.handleSetUpOneSheet(item)
          }
        }
      }, [_vm._v("One sheet")]), _vm._v("\n                  ]\n                ")]) : _vm._e(), _vm._v(" "), (item.chart == 'WORDCLOUD') ? _c('span', [_vm._v("\n                  [\n                  "), _c('a', {
        on: {
          "click": function($event) {
            return _vm.handleCSVExport(item)
          }
        }
      }, [_vm._v("Download")]), _vm._v("\n                  ]\n                ")]) : _vm._e()]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(item.question))]), _vm._v(" "), _c('div', {
        staticClass: "clearfix"
      })]), _vm._v(" "), _c('span', {
        attrs: {
          "slot": "content"
        },
        slot: "content"
      }, [_c('div', {
        staticClass: "chart-content"
      }, [(item.chart.length === 0 || item.chart === 'VERTICAL_BAR') ? _c('bar-chart', {
        attrs: {
          "height": 300,
          "colorCycle": [_vm.generateTitleColor(item.question, _vm.hueRange)],
          "data": _vm.totalDisplay(item.answers),
          "options": _vm.chartOptions
        },
        on: {
          "onClick": function($event) {
            return _vm.handleChartClicked($event, item)
          }
        }
      }) : _vm._e(), _vm._v(" "), (item.chart === 'VERTICAL_BAR_STACKED') ? _c('stacked-bar-chart', {
        attrs: {
          "height": 300,
          "showLegend": true,
          "legendPosition": 'bottom',
          "colorCycle": [_vm.generateTitleColor(item.question, _vm.hueRange)],
          "data": _vm.stackedTotalDisplay(item.answers),
          "options": _vm.stackedChartOptions
        },
        on: {
          "onClick": function($event) {
            return _vm.handleChartClicked($event, item)
          }
        }
      }) : _vm._e(), _vm._v(" "), (item.chart === 'HORIZONTAL_BAR') ? _c('horizontal-bar-chart', {
        attrs: {
          "height": 300,
          "colorCycle": [_vm.generateTitleColor(item.question, _vm.hueRange)],
          "data": _vm.totalDisplay(item.answers),
          "options": _vm.chartOptions
        },
        on: {
          "onClick": function($event) {
            return _vm.handleChartClicked($event, item)
          }
        }
      }) : _vm._e(), _vm._v(" "), (item.chart === 'PIE') ? _c('pie-chart', {
        attrs: {
          "height": 300,
          "colorCycle": _vm.generateColorPool(_vm.totalDisplay(item.answers), _vm.hueRange),
          "data": _vm.totalDisplay(item.answers),
          "options": _vm.pieChartOptions
        },
        on: {
          "onClick": function($event) {
            return _vm.handleChartClicked($event, item)
          }
        }
      }) : _vm._e(), _vm._v(" "), (item.chart === 'DONUT') ? _c('donut-chart', {
        attrs: {
          "height": 300,
          "colorCycle": _vm.generateColorPool(_vm.totalDisplay(item.answers), _vm.hueRange),
          "data": _vm.totalDisplay(item.answers),
          "options": _vm.pieChartOptions
        },
        on: {
          "onClick": function($event) {
            return _vm.handleChartClicked($event, item)
          }
        }
      }) : _vm._e(), _vm._v(" "), (item.chart == 'WORDCLOUD') ? _c('cloud', {
        attrs: {
          "data": item.answers.words || [],
          "fontSizeMapper": _vm.fontSizeMapper,
          "width": 370,
          "height": 280,
          "padding": 3
        }
      }) : _vm._e()], 1), _vm._v(" "), _c('div', {
        staticClass: "legend-content"
      }, [(['HORIZONTAL_BAR', 'VERTICAL_BAR'].includes(item.chart)) ? _c('chart-legend', {
        attrs: {
          "colorCycle": [_vm.generateTitleColor(item.question, _vm.hueRange)],
          "data": _vm.totalDisplay(item.answers),
          "isPercentage": _vm.selectedTotalDisplay === 'percentage'
        }
      }) : _vm._e(), _vm._v(" "), (['PIE', 'DONUT'].includes(item.chart)) ? _c('chart-legend', {
        attrs: {
          "colorCycle": _vm.generateColorPool(_vm.totalDisplay(item.answers), _vm.hueRange),
          "data": _vm.totalDisplay(item.answers),
          "isPercentage": _vm.selectedTotalDisplay === 'percentage'
        }
      }) : _vm._e()], 1)])])], 1)
    }), 0)
  }), _vm._v(" "), (_vm.positiveCategoryProfiles.profiles && !_vm.isViewingAllCategories()) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('respondent-profile-chart', {
    attrs: {
      "title": "Only positive respondents",
      "heading": ("Demographic of our listenership that shown interest in " + _vm.currentCategory),
      "profileCharts": _vm.positiveCategoryProfiles.profiles,
      "totalRespondents": _vm.positiveCategoryProfiles.respondents,
      "selectedTotalDisplay": _vm.selectedTotalDisplay,
      "hueRange": _vm.colorPieChartSpectrum
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.categoryProfiles.profiles) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('respondent-profile-chart', {
    attrs: {
      "title": "All respondents",
      "heading": ("Demographic of our listenership that completed questions on " + _vm.currentCategory),
      "profileCharts": _vm.categoryProfiles.profiles,
      "totalRespondents": _vm.categoryProfiles.respondents,
      "selectedTotalDisplay": _vm.selectedTotalDisplay,
      "hueRange": _vm.respHueRange
    }
  })], 1)]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "categories col-lg-2 sidebar"
  }, [_c('h3', [_vm._v("Categories")]), _vm._v(" "), _c('el-menu', {
    staticClass: "survey-analytics-menu",
    attrs: {
      "default-active": _vm.selectedCategory
    }
  }, [_c('el-menu-item', {
    key: 'All',
    attrs: {
      "index": "All",
      "active": _vm.currentCategory === 'All'
    },
    on: {
      "click": function($event) {
        _vm.selectedCategory = 'All'
      }
    }
  }, [_vm._v("All Categories")]), _vm._v(" "), _vm._l((_vm.surveyStats.surveyCategories), function(category) {
    return _c('el-menu-item', {
      key: category,
      attrs: {
        "index": category,
        "active": category === _vm.currentCategory
      },
      on: {
        "click": function($event) {
          _vm.selectedCategory = category
        }
      }
    }, [_vm._v(_vm._s(category))])
  })], 2)], 1)]) : _vm._e(), _vm._v(" "), _c('survey-export-form-dialog', {
    attrs: {
      "isVisible": _vm.exportFormDialogVisible,
      "filterBy": _vm.filterBy,
      "surveyId": parseInt(_vm.selectedSurvey, 10),
      "surveyName": _vm.surveyName,
      "periodType": _vm.selectedPeriod,
      "datetime": new Date(_vm.selectedDatetime)
    },
    on: {
      "onVisibilityChange": _vm.handleExportFormDialogVisibility
    }
  }), _vm._v(" "), _c('survey-export-view-dialog', {
    attrs: {
      "isVisible": _vm.exportViewDialogVisible
    },
    on: {
      "onVisibilityChange": _vm.handleExportViewDialogVisibility
    }
  }), _vm._v(" "), (_vm.oneSheetData && Object.keys(_vm.oneSheetData).length > 0) ? _c('category-one-sheet', {
    attrs: {
      "visible": _vm.oneSheetVisible,
      "title": _vm.selectedCategory,
      "statData": _vm.oneSheetData,
      "selectedTotalDisplay": _vm.selectedTotalDisplay
    },
    on: {
      "onChangeVisibility": function (visible) { return (_vm.oneSheetVisible = visible); }
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-3"
  }, [_c('h1', [_vm._v("Qualitative Surveys")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "empty"
  }, [_vm._v("No data found, please select your filters.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c1a87a40","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/surveys/SurveyAnalyticsDashboard.vue
// module id = 3388
// module chunks = 3